module.exports = __webpack_public_path__ + "img/social_media_kuaishou.1b1ca95b.png";